import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { createEmptyTaskDrawerState } from './taskDrawer.state.utils'
import { fetchDrawerTaskThunk, syncDrawerTaskThunk } from './taskDrawer.thunks'

const taskDrawerSlice = createSlice({
  name: 'taskTrackerTaskDrawer',
  initialState: createEmptyTaskDrawerState(),
  reducers: {
    setTaskDrawerSuppressedTaskId(
      state,
      action: PayloadAction<number | null>,
    ) {
      state.suppressedTaskId = action.payload
    },
    clearTaskDrawerOverride(state) {
      state.drawerTaskOverride = null
      state.drawerTaskLoading = false
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDrawerTaskThunk.pending, (state, action) => {
        if (action.meta.arg.silent) return
        state.drawerTaskLoading = true
      })
      .addCase(fetchDrawerTaskThunk.fulfilled, (state, action) => {
        if (!action.meta.arg.silent) {
          state.drawerTaskLoading = false
        }
        if (action.payload.task.boardId !== action.payload.boardId) {
          if (!action.meta.arg.silent) {
            state.drawerTaskOverride = null
          }
          return
        }
        state.drawerTaskOverride = action.payload.task
      })
      .addCase(fetchDrawerTaskThunk.rejected, (state, action) => {
        if (action.meta.arg.silent) return
        state.drawerTaskLoading = false
        state.drawerTaskOverride = null
      })
      .addCase(syncDrawerTaskThunk.pending, (state, action) => {
        state.syncingTaskIds[action.meta.arg.taskId] = true
      })
      .addCase(syncDrawerTaskThunk.fulfilled, (state, action) => {
        const { taskId, task } = action.payload
        delete state.syncingTaskIds[taskId]
        if (state.drawerTaskOverride?.id === taskId) {
          state.drawerTaskOverride = task
        }
      })
      .addCase(syncDrawerTaskThunk.rejected, (state, action) => {
        const payload = action.payload as {
          taskId: number
          fallbackTask: import('../domain.types').TaskTrackerBoardCard
        }
        delete state.syncingTaskIds[payload.taskId]
        if (state.drawerTaskOverride?.id === payload.taskId) {
          state.drawerTaskOverride = payload.fallbackTask
        }
      })
  },
})

export const { setTaskDrawerSuppressedTaskId, clearTaskDrawerOverride } =
  taskDrawerSlice.actions

export default taskDrawerSlice.reducer
